<div class="clug-list-card">
  <div class="card-loader" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div class="card-header">
    <span class="card-header-count">{{totalCount}} Candidate(s)</span>
    <div class="input-group">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search candidates..." [(ngModel)]="candidateSearch" (keyup)="searchCandidate()">
    </div>
  </div>

  <div class="table-responsive">
    <table matSort (matSortChange)="sortData($event)" class="table">
      <thead>
        <tr>
          <th mat-sort-header="name" scope="col">Name</th>
          <th mat-sort-header="email" scope="col">Email</th>
          <th mat-sort-header="email" scope="col">SSN/NI</th>
          <th mat-sort-header="email" scope="col">Identifier</th>
          <th mat-sort-header="created_at" scope="col">Created At</th>
          <th mat-sort-header="action" scope="col" class="actions-col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let candidate of allCandidates; let i = index" class="dataColumn">
          <td>
            <div class="contractor-cell">
              <div class="avatar" *ngIf="candidate.profile_pic">
                <img alt="" src="{{dataSharedService.getImage(candidate.profile_pic)}}">
              </div>
              <div class="avatar" *ngIf="!candidate.profile_pic">
                <span>{{authService.getInitials(candidate.name)}}</span>
              </div>
              <span class="contractor-name">{{candidate.name}}</span>
            </div>
          </td>
          <td>{{candidate.email}}</td>
          <td>{{candidate.ssn}}</td>
          <td>{{candidate.identifier}}</td>
          <td>{{dataSharedService.getFormatedDate(candidate.created_at)}}</td>
          <td class="td-actions">
            <div class="row-actions">
              <button type="button" class="icon-btn-sm" matTooltip="Resend Account Creation Mail" [matTooltipPosition]="'left'" (click)="resendAccountActivation(candidate.uuid)">
                <i class="bi bi-link"></i>
              </button>
              <button type="button" class="icon-btn-sm reject" matTooltip="Deactivate account" [matTooltipPosition]="'left'" (click)="showEmploymentEndDateModal(candidate.uuid)">
                <i class="bi bi-lock"></i>
              </button>
              <button type="button" class="icon-btn-sm" matTooltip="Get Account Creation Link" [matTooltipPosition]="'left'" (click)="generateAccountCreationLink(candidate.uuid)">
                <i class="bi bi-file-lock"></i>
              </button>
              <button type="button" class="icon-btn-sm info" matTooltip="Edit Candidate" [matTooltipPosition]="'left'" (click)="editCandidate(candidate)">
                <i class="bi bi-pencil"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-pagination" *ngIf="totalCount">
    <span class="pagination-summary">
      Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} candidates
    </span>
    <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
  </div>
</div>
